import { CRMAPIBase } from '@api/crmApiBase';
import { ChatResp } from '@api/responseModels/chats/chatResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class ChatGroup extends CRMAPIBase {
    async createChat({
        crm_id,
        name,
        chat_group_id,
    }: {
        crm_id: number;
        name: string;
        chat_group_id: number;
    }): Promise<RequestResult<ChatResp>> {
        const response = await this.post<ChatResp>(`/chats`, { crm_id, name, chat_group_id });
        return response;
    }

    async deleteChat({
        chat_id,
        crm_id,
    }: {
        chat_id: number;
        crm_id: number;
    }): Promise<RequestResult<ChatResp>> {
        const response = await this.delete<ChatResp>(`/chats/${chat_id}`, { crm_id });
        return response;
    }

    async updateChat({
        chat_id,
        crm_id,
        name,
        chat_group_id,
    }: {
        chat_id: number;
        crm_id: number;
        name: string;
        chat_group_id: number;
    }): Promise<RequestResult<ChatResp>> {
        const response = await this.put<ChatResp>(`/chats/${chat_id}`, {
            crm_id,
            name,
            chat_group_id,
        });
        return response;
    }

    /**
     * Добавление участников чата.
     *
     * Возвращает не чат, а код `RECIPIENTS_ADDED` со статусом 201
     * (`ChatMessageService::addParticipants`), поэтому тела ответа здесь нет.
     */
    async updateChatParticipants({
        chat_id,
        participants,
    }: {
        chat_id: number;
        participants: Array<number>;
    }): Promise<RequestResult<null>> {
        const response = await this.post<null>(`/chats/${chat_id}/participants`, {
            participants,
        });
        return response;
    }

    /** Чат вместе с сообщениями, участниками и последним сообщением */
    async getChat({
        chat_id,
        crm_id,
    }: {
        chat_id: number;
        crm_id: number;
    }): Promise<RequestResult<ChatResp>> {
        const response = await this.get<ChatResp>(`/chats/${chat_id}`, { crm_id });
        return response;
    }
}

export { ChatGroup };
